export type ApiModule =
  | 'admin'
  | 'auth'
  | 'chat'
  | 'search'
  | 'avatar'
  | 'contact-center'
  | 'conversations'
  | 'documents'
  | 'doctors'
  | 'dr-query-coach'
  | 'evaluation'
  | 'finops'
  | 'knowledge-check'
  | 'mcp'
  | 'notifications'
  | 'roleplay'
  | 'summarization'
  | 'userFeedback'
  | 'secrets'

export type ApiRoutingConfig = {
  micro_architecture_flag: boolean;
  moduleVersions: Record<ApiModule, string>;
  migratedModules: Record<ApiModule, boolean>;
  monolithContext: string;
  microserviceContext: string;
};

export const API_ROUTING_CONFIG: ApiRoutingConfig = {
  // Quick rollback switch. false keeps all module routes on monolith.
  micro_architecture_flag: true,
  moduleVersions: {
    'admin': 'v1',
    'auth': 'v1',
    'chat': 'v1',
    'search': 'v1',
    'avatar': 'v1',
    'contact-center': 'v1',
    'conversations': 'v1',
    'documents': 'v1',
    'doctors': 'v1',
    'dr-query-coach': 'v1',
    'evaluation': 'v1',
    'finops': 'v1',
    'knowledge-check': 'v1',
    'mcp': 'v1',
    'notifications': 'v1',
    'roleplay': 'v1',
    'summarization': 'v1',
    'userFeedback': 'v1',
    'secrets': 'v1',
  },
  // Module-by-module migration status.
  migratedModules: {
    'admin': true,
    'auth': true,
    'chat': true,
    'search': true,
    'avatar': true,
    'contact-center': true,
    'conversations': true,
    'documents': true,
    'doctors': false,
    'dr-query-coach': true,
    'evaluation': true,
    'finops': true,
    'knowledge-check': true,
    'mcp': true,
    'notifications': true,
    'roleplay': true,
    'summarization': true,
    'userFeedback': false,
    'secrets': true,
  },
  monolithContext: 'genai',
  microserviceContext: 'api'
};